import React from 'react'
import Serviceimg from '../assets/media/servicecard.png'
import SpotlightCard from '../Reactbits/SpotlightCard/SpotlightCard';
  
function ServiceCard({title , tech , desc}) {
  return (
    <SpotlightCard className="custom-spotlight-card" spotlightColor="rgba(255, 238, 0, 0.52)">
    <div className='ser-card'>
        <h4>
        {
            title
        }
        </h4>

        <div className="tech-box">
            <h5>
              {tech}
            </h5>
            <h5>
                Responsive UI
            </h5>
        </div>

        <p>
          {desc}
        </p>

        {/* <img src={Serviceimg} alt="" /> */}
    </div>
    </SpotlightCard>
  )
}

export default ServiceCard
